import { render, staticRenderFns } from "./CommissionTurnoverAndRevenueReport.vue?vue&type=template&id=2dc97a0c&scoped=true"
import script from "./CommissionTurnoverAndRevenueReport.vue?vue&type=script&lang=js"
export * from "./CommissionTurnoverAndRevenueReport.vue?vue&type=script&lang=js"
import style0 from "./CommissionTurnoverAndRevenueReport.vue?vue&type=style&index=0&id=2dc97a0c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dc97a0c",
  null
  
)

export default component.exports